import { Api, ConfigHelper, createApiService } from 'relapp-api';
import store from '@/store/index.js';

export default {
    ...createApiService('vps'),

    /**
     * Get basic VPS info.
     *
     * @param {string} domainName
     * @param {string} serverId
     *
     * @return {Promise}
     */
    vpsShow(domainName, serverId) {
        const route = ConfigHelper.apiUrl('vps.show', [
            {
                key: '{domain}',
                value: domainName
            },
            {
                key: '{vps}',
                value: serverId
            }
        ]);

        return Api.get(route);
    },

    /**
     * Get detailed VPS info.
     *
     * @param {string} domainName
     * @param {string} serverId
     *
     * @return {Promise}
     */
    vpsDetails(domainName, serverId) {
        const route = ConfigHelper.apiUrl('vps.details', [
            {
                key: '{domain}',
                value: domainName
            },
            {
                key: '{vps}',
                value: serverId
            }
        ]);

        return Api.get(route);
    },

    /**
     * Start VPS
     *
     * @param {string} domainName
     * @param {string} serverId
     *
     * @return {Promise}
     */
    start(domainName, serverId) {
        const route = ConfigHelper.apiUrl('vps.start', [
            {
                key: '{domain}',
                value: domainName
            },
            {
                key: '{vps}',
                value: serverId
            }
        ]);

        return Api.post(route);
    },

    /**
     * Stop VPS
     *
     * @param {string} domainName
     * @param {string} serverId
     *
     * @return {Promise}
     */
    stop(domainName, serverId) {
        const route = ConfigHelper.apiUrl('vps.stop', [
            {
                key: '{domain}',
                value: domainName
            },
            {
                key: '{vps}',
                value: serverId
            }
        ]);

        return Api.post(route);
    },

    /**
     * Reboot VPS
     *
     * @param {string} domainName
     * @param {string} serverId
     *
     * @return {Promise}
     */
    reboot(domainName, serverId) {
        const route = ConfigHelper.apiUrl('vps.reboot', [
            {
                key: '{domain}',
                value: domainName
            },
            {
                key: '{vps}',
                value: serverId
            }
        ]);

        return Api.post(route);
    },

    /**
     * Reset Password VPS
     *
     * @param {string} domainName
     * @param {string} serverId
     * @param {object} password
     *
     * @return {Promise}
     */
    resetPassword(domainName, serverId, password) {
        const route = ConfigHelper.apiUrl('vps.reset-password', [
            {
                key: '{domain}',
                value: domainName
            },
            {
                key: '{vps}',
                value: serverId
            }
        ]);

        return Api.post(route, password);
    },

    /**
     * Delete VPS
     *
     * @param {string} domainName
     * @param {string} serverId
     *
     * @return {Promise}
     */
    deleteVps(domainName, serverId) {
        const route = ConfigHelper.apiUrl('vps.delete', [
            {
                key: '{domain}',
                value: domainName
            },
            {
                key: '{vps}',
                value: serverId
            }
        ]);

        return Api.delete(route);
    },

    /**
     * Get list of cloud templates
     *
     * @return {Promise}
     */
    templates() {
        const route = ConfigHelper.apiUrl('vps.templates.get');

        return Api.get(route).then(response => {
            let storeData = null;

            if (response.data.data) {
                storeData = response.data.data;
            }
            if (storeData) {
                store.dispatch('vps/updateTemplates', storeData);
            }

            return response;
        });
    },

    /**
     * Change the display name subdomain
     * @param domainName
     * @param serverId
     * @param hostname
     * @returns {Promise}
     */
    updateSubdomain(domainName, serverId, hostname) {
        const route = ConfigHelper.apiUrl('vps.update-subdomain', [
            {
                key: '{domain}',
                value: domainName
            },
            {
                key: '{vps}',
                value: serverId
            }
        ]);

        return Api.put(route, hostname);
    },


    /**
     * Upgrade the server offering
     * @param domainName
     * @param serverId
     * @param hostname
     * @returns {Promise}
     */
    upgradeServer(domainName, serverId, data) {
        const route = ConfigHelper.apiUrl('vps.upgrade-server', [
            {
                key: '{domain}',
                value: domainName
            },
            {
                key: '{vps}',
                value: serverId
            }
        ]);

        return Api.put(route, data);
    }
};
